import { Box } from "@mui/material";
import React from "react";
import RevSelection from "../InputData/RevSelection";
import SpecTabs from "./SpecTabs";

export default function SpecPanel() {
  return (
    <Box sx={{ backgroundColor: "#fff", p: 1 }}>
      <Box sx={{}}>
        <RevSelection />
        <SpecTabs />
      </Box>
    </Box>
  );
}
